export default __webpack_public_path__ + "static/media/Pao-Davo.47d202f4.jpg";